/** Line item as returned by the admin orders read (#2241): OrderDetails + its EventProducts. */
export interface OrderLineI {
  id: string;
  quantity?: number | null;
  unit_price?: number | null;
  subTotal?: number | null;
  serviceFee?: number | null;
  totalAmount?: number | null;
  productsPurchased?: { id: string; stripeProductName?: string | null; description?: string | null } | null;
}

/**
 * #2241 — mirrors what the tenant-scoped admin orders `findOne` actually
 * returns (order + payment/booking/event/line-item includes). All fields the
 * API may omit are optional; dates arrive as ISO strings over HTTP.
 */
export interface OrderI {
  id: string;
  firstName: string;
  lastName?: string | null;
  emailAddress?: string | null;
  orderNumber?: string | null;
  orderDate?: string | null;
  status?: string | null;
  customerId?: string | null;
  bookingId?: string | null;
  paymentId?: string | null;
  testingEventId?: string | null;
  createdAt?: string | null;
  orderDetails?: OrderLineI[] | null;
  payment?: {
    id: string;
    amount?: number | null;
    status?: string | null;
    stripePaymentIntentId?: string | null;
  } | null;
  booking?: { id: string; status?: string | null } | null;
  ordersForTestingEvent?: {
    id: string;
    testEventName?: string | null;
    testEventAtClub?: { id: string; clubName?: string | null } | null;
  } | null;
}
// address: '800 Stan Circle';
// bodyFatMeasureTestProductId: null;
// city: 'New Judahstead';
// country: 'USA';
// createdAt: '2023-11-09T00:15:09.368Z';
// customerId: null;
// emailAddress: 'Funk';
// employee_id: null;
// firstName: 'Claudia';
// freight: null;
// id: 'add4b065-c42d-4a8e-8db4-8c16572e4db9';
// lastName: 'Funk';
// linksId: null;
// mealPlanId: null;
// operatorId: null;
// orderDate: '2023-11-09T00:15:09.368Z';
// orderNumber: 'qCksW';
// paymentId: null;
// required_date: '2023-11-09T00:00:00.000Z';
// ship_via: null;
// shipped_date: '2024-10-04T00:00:00.000Z';
// testingEventId: null;
// trainerId: null;
// updatedAt: '2023-11-09T00:15:09.368Z';
// zipCode: '31533-1200';
export interface OrderTotalResponseI {
  total: number;
}
